export const ACTION_CREATE_CERTIFICATE__REQUEST = 'ACTION_CREATE_CERTIFICATE__REQUEST';
export const ACTION_CREATE_CERTIFICATE__SUCCESS = 'ACTION_CREATE_CERTIFICATE__SUCCESS';
export const ACTION_CREATE_CERTIFICATE__FAIL = 'ACTION_CREATE_CERTIFICATE__FAIL';

export const ACTION_LOAD_CERTIFICATE_STATUS__REQUEST = 'ACTION_LOAD_CERTIFICATE_STATUS__REQUEST';
export const ACTION_LOAD_CERTIFICATE_STATUS__SUCCESS = 'ACTION_LOAD_CERTIFICATE_STATUS__SUCCESS';
export const ACTION_LOAD_CERTIFICATE_STATUS__FAIL = 'ACTION_LOAD_CERTIFICATE_STATUS__FAIL';
